'use client'

import { createContext, useContext, type ReactNode } from 'react'

export type SigmaSurface = 'app' | 'portal'

const SigmaSurfaceContext = createContext<SigmaSurface>('app')

export function SigmaSurfaceProvider({
  surface,
  children,
}: {
  surface: SigmaSurface
  children: ReactNode
}) {
  return <SigmaSurfaceContext.Provider value={surface}>{children}</SigmaSurfaceContext.Provider>
}

export function useSigmaSurface(): SigmaSurface {
  return useContext(SigmaSurfaceContext)
}
